<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Check In</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'CheckInImage')"
            [blockData]="block.variables?.CheckInImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="CheckInImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'CheckInHeading')"
            [blockData]="block.variables?.CheckInHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="CheckInHeading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'CheckInText')"
            [blockData]="block.variables?.CheckInText ?? ''"
            [placeholder]="textPlaceholder"
            variable="CheckInText"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'CheckInImageHref')"
            [blockData]="block.variables?.CheckInImageHref ?? ''"
            [placeholder]="hrefPlaceholder"
            variable="CheckInImageHref"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'CheckInImageHrefSegmentRegex')
            "
            [selectedSegment]="
              block.variables?.CheckInImageHrefSegmentRegex ?? ''
            "
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'alt'"
            (handleOnChange)="onChange($event, 'CheckInImageAlt')"
            [blockData]="block.variables?.CheckInImageAlt ?? ''"
            [placeholder]="altPlaceholder"
            variable="CheckInImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'CheckInCtaLink')"
            [blockData]="block.variables?.CheckInCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="CheckInCtaLink"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'CheckInCtaLinkSegmentRegex')
            "
            [selectedSegment]="
              block.variables?.CheckInCtaLinkSegmentRegex ?? ''
            "
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="30"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'CheckInCtaText')"
            [blockData]="block.variables?.CheckInCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            variable="CheckInCtaText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-left">
          <div *ngIf="block.variables?.CheckInImage" class="col-4">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.CheckInImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.CheckInImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.CheckInImageAlt)"
            /></a>
          </div>
          <div class="row text-left col-8">
            <div
              class="col-12"
              [innerHTML]="$safeNavigationMigration(block.variables?.CheckInHeading)"
            ></div>
            <div
              class="col-12"
              [innerHTML]="$safeNavigationMigration(block.variables?.CheckInText)"
            ></div>
            <div class="col-12">
              <a
                target="_blank"
                *ngIf="block.variables?.CheckInCtaLink"
                class="btn btn-primary"
                [href]="$safeNavigationMigration(block.variables?.CheckInCtaLink)"
                role="button"
                [innerHTML]="$safeNavigationMigration(block.variables?.CheckInCtaText)"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
